import Swal from "sweetalert2";
import "./sweetalert.css";

const AlertService = {
  success: (title, text, confirmText = "OK") => {
    Swal.fire({
      title: title || "Success!",
      text: text || "Operation completed successfully.",
      icon: "success",
      confirmButtonText: confirmText,
    });
  },

  error: (title, text, confirmText = "OK") => {
    Swal.fire({
      title: title || "Error!",
      text: text || "Something went wrong.",
      icon: "error",
      confirmButtonText: confirmText,
    });
  },

  warning: (title, text, confirmText = "Proceed", cancelText = "Cancel") => {
    return Swal.fire({
      title: title || "",
      text: text || "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
    });
  },

  info: (title, text, confirmText = "OK") => {
    Swal.fire({
      title: title || "Info",
      text: text || "Here's some important information.",
      icon: "info",
      confirmButtonText: confirmText,
    });
  },

  confirm: async (title, text, confirmText = "Proceed", cancelText = "Cancel") => {
    return Swal.fire({
      title: title || "",
      text: text || "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
    }).then((result) => result.isConfirmed);
  },

  reminder: (title, text, confirmText = "Acknowledge", cancelText = "Ignore") => {
    return Swal.fire({
      title: title || "",
      text: text || "Here's some important information.",
      icon: "",
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      allowOutsideClick: false,
      allowEscapeKey: false, 
      customClass: {
        title: "custom-title",
        htmlContainer: "custom-text",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button"
      }
    });
  },

  scheduleReminder: (title, text, confirmText = "Acknowledge", cancelText = "Ignore") => {
    return Swal.fire({
      title: title || "",
      html: text || "Here's some important information.",
      icon: "",
      showCancelButton: false,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      allowOutsideClick: false,
      allowEscapeKey: false, 
      customClass: {
        title: "custom-title",
        htmlContainer: "custom-text",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button"
      }
    });
  },

  reminderConfirm: (title, text, confirmText = "Acknowledge") => {
    return Swal.fire({
      title: title || "",
      text: text || "Here's some important information.",
      icon: "",
      showCancelButton: true,
      confirmButtonText: confirmText,
      allowOutsideClick: false,
      allowEscapeKey: false, 
      customClass: {
        title: "custom-title",
        htmlContainer: "custom-text",
        confirmButton: "custom-confirm-button",
      }
    });
  },
};

export default AlertService;
